function makeGoogleUrl(baseUrl: string, query: string): string {
  if (!query) {
    return '';
  }
  const url = new URL(baseUrl);
  url.searchParams.set('q', query);
  return url.href;
}

export function makeGoogleSearchUrl<
  T extends {
    full_name?: string;
    birth_date?: Date | null;
    birth_year?: number;
    municipality_name?: string;
  },
>(item: T): string {
  if (item) {
    let query = '';
    if (item.full_name) {
      query += ' "' + item.full_name + '"';
    }
    if (item.birth_year) {
      query += ' ' + String(item.birth_year);
    } else if (item.birth_date) {
      query += ' ' + String(item.birth_date.getFullYear());
    }
    if (item.municipality_name) {
      query += ' ' + item.municipality_name;
    }
    return makeGoogleUrl('https://www.google.com/search', query.trim());
  }
  return '';
}

export function makeGoogleMapsUrl<
  T extends {
    street_address?: string;
    postal_code?: string;
    postal_place?: string;
  },
>(item: T): string {
  if (item) {
    let query = '';
    if (item.street_address) {
      query += ' ' + item.street_address;
    }
    if (item.postal_code) {
      query += ' ' + item.postal_code;
    }
    if (item.postal_place) {
      query += ' ' + item.postal_place;
    }
    return makeGoogleUrl('https://www.google.com/maps', query.trim());
  }
  return '';
}

export function makeGoogleMapsUrlFromQuery(query: string): string {
  return makeGoogleUrl('https://www.google.com/maps', query);
}
